/* Function declaration of getRecommendedProductsStatus */  
window.getRecommendedProductsStatus = function() {
    var element = window.document.querySelector('body');
    return element ? element.getAttribute('data-recommended-products') === 'true' : false;
};

/* Check if the device is a mobile device based on screen width */  
window.isMobileDevice = function() {
    return window.innerWidth <= 767; // You can adjust the threshold as needed
}

/* Check if the device is a desktop device based on screen width */  
window.isDesktopDevice = function() {
    return window.innerWidth >= 768; // You can adjust the threshold as needed
}

/* Deselect All Selected Item Function in BYOB Collection */
function removeAllSelectedItem() {
  // console.log("Deselect All Selected Item Function Run")
    var elements = document.querySelectorAll('.active-product .selected_mark');
    elements.forEach(function(element) {
        element.click();
    });
    $("#m-checkout-products .checkout-btn-text").show();
    $("#m-checkout-products .m-spinner-border").hide();
    if($(".active-product .selected_mark").length <= 0){
       $("#m-checkout-products").attr("disabled", true);
     }
}

/* Add to cart function */
window.addToCart = function(formData, behavior) {
  if (behavior === 'refresh_drawer'){
    document.querySelector('cart-drawer#cart-drawer').classList.add('m-line-item-change-animation');
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    
    if (behavior === 'open_drawer') {
        document.querySelector('[data-cart-drawer-open]').click();
    } else if (behavior === 'refresh_drawer') {
        $("#m-recommended-products-section").show();
        document.querySelector('cart-drawer#cart-drawer').classList.remove('m-line-item-change-animation');
    } else {
        window.location.reload();
    }
    if($(".active-product .selected_mark").length > 0){
      removeAllSelectedItem();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    document.querySelector('cart-drawer#cart-drawer').classList.remove('m-line-item-change-animation');
  });
};

/* Modify Line Item function */
window.modifyLineItem = function(line_item_key, formData, behavior) {
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      "quantity": 0,
      "id": line_item_key
    },
    success: function(data) {
      // console.log('Product updated successfully', data);
      if (behavior === 'refresh_drawer') {
      window.addToCart(formData,'refresh_drawer' );
      }else{
      window.addToCart(formData,'reload_page' );
      }
    },
    error: function(xhr, status, error) {
      // console.error('Error updating product', status);
    }
  });
};

$(document).ready(function () {
  $('body').on('change', '#m-main-cart .m-line-item-variants', function () {
  const id = $(this).val();
  const selectedOption = $(this).find('option:selected');
  var selectedVariantAvailabilityQty = parseInt(selectedOption.attr("data-item-availability"), 10);
  var lineItemCurrentQty = parseFloat($(this).closest(".line-item").find(".quantity-selector__input").val());
  var qty; 

  if (lineItemCurrentQty > selectedVariantAvailabilityQty) {
    qty = selectedVariantAvailabilityQty;
  } else {
    qty = lineItemCurrentQty;
  }

  const line_item_key = $(this).closest(".line-item").find(".quantity-selector__input").attr("data-line-key");
  
  let formData = {
    'items': [{
      'id': id,
      'quantity': qty
    }]
  };

/* Remove line-item form cart */
window.modifyLineItem(line_item_key, formData, 'reload_page');
});
  
/* On change event trigger when line-item will change in selectbox in cart drawer */
$('body').on('change', '.m__cart__drawer__items .m-line-item-variants', function () {
  const id = $(this).val();
  const selectedOption = $(this).find('option:selected');
  var selectedVariantAvailabilityQty = parseInt(selectedOption.attr("data-item-availability"), 10);
  var lineItemCurrentQty = parseFloat($(this).closest(".line-item").find(".quantity-selector__input").val());

  // console.log(lineItemCurrentQty, selectedVariantAvailabilityQty);

  var qty;  // Declare qty variable outside the if-else blocks

  if (lineItemCurrentQty > selectedVariantAvailabilityQty) {
    qty = selectedVariantAvailabilityQty;
    // console.log("Selected Variant Availability Qty : ", qty);
  } else {
    qty = lineItemCurrentQty;
    // console.log("Line Item Current Qty : ", lineItemCurrentQty);
  }

  const line_item_key = $(this).closest(".line-item").find(".quantity-selector__input").attr("data-line-key");
  
  let formData = {
    'items': [{
      'id': id,
      'quantity': qty
    }]
  };

/* Remove line-item form cart */
window.modifyLineItem(line_item_key, formData, 'refresh_drawer');
});
});

// COLLECTION AND SEARCH FILTERS
  $(document).ready(function(){
    $('.coll-m-clickable-swatch').click(function(){
      console.log('clicked');
      var mainImg = $(this).attr('data-src');
      var prodUrl= $(this).attr('data-url');
      var atcProd = $(this).attr('data-id');
      $(this).parents('.m__product_card').find('.product-card__image').attr('srcset',mainImg);
      $(this).parents('.m__product_card').find('.m_prod_link').attr('href',prodUrl);
      $(this).parents('.m__product_card').find('.m__prod_title').attr('href',prodUrl);
      $(this).parents('.m__product_card').find('.atc_btn-input').attr('value',atcProd);
      $(this).parents('.m__product_card').find('.coll-m-clickable-swatch').removeClass('m_active-item');
      $(this).addClass('m_active-item');
    });

    // COLLECTION FILTERS   
    // function facetWrapperVisibility() {
    //   if($('.removableFacetsWrapper .removable-facet').length <= 0) {
    //     $('.m_drawerRemovableFacets').hide();
    //   } else {
    //     $('.m_drawerRemovableFacets').css('display', 'flex');
    //   }
    // }
    // function autoFetchFacets() {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const gte = urlParams.get('filter.v.price.gte');
    //   const lte = urlParams.get('filter.v.price.lte');
    //   $('body').find('#facets-drawer input').each(function(){
    //     var input = $(this);
    //     if(input.is(':checked')) {
    //       var value = input.val();
    //       if($('.removableFacetsWrapper .removable-facet[data-value="'+value+'"]').length <= 0) {
    //         var removableFacet = '<div class="removable-facet" data-value="'+value+'"><svg style="color: white" aria-hidden="true" focusable="false" fill="none" width="7" class="icon icon-close" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path></svg><span class="text-subdued">'+value+'</span></div>';
    //         $('.m_drawerRemovableFacets .removableFacetsWrapper').append(removableFacet);
    //       }
    //     }
    //     if(input.is('[aria-label="From price"]')) {
    //       var value = parseInt(input.val(), 10);
    //       if($('.removableFacetsWrapper .removable-facet.minPrice').length <= 0 && gte != null) {
    //         var removableFacet = '<div class="removable-facet minPrice" data-value="'+value+'"><svg style="color: white" aria-hidden="true" focusable="false" fill="none" width="7" class="icon icon-close" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path></svg><span class="text-subdued">≥ '+value+'</span></div>';
    //         $('.m_drawerRemovableFacets .removableFacetsWrapper').append(removableFacet);
    //       }
    //     }
    //     if(input.is('[aria-label="To price"]')) {
    //       var value = parseInt(input.val(), 10);
    //       if($('.removableFacetsWrapper .removable-facet.maxPrice').length <= 0 && lte != null) {
    //         var removableFacet = '<div class="removable-facet maxPrice" data-value="'+value+'"><svg style="color: white" aria-hidden="true" focusable="false" fill="none" width="7" class="icon icon-close" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path></svg><span class="text-subdued">≤ '+value+'</span></div>';
    //         $('.m_drawerRemovableFacets .removableFacetsWrapper').append(removableFacet);
    //       }
    //     }
    //   });
    //   facetWrapperVisibility();
    // }
    // autoFetchFacets();
    // $('body').on('click', '#facets-drawer .facets-clear-all', function(){
    //   $('.m_drawerRemovableFacets .removableFacetsWrapper').html('');
    //   $('body').find('.collection__main .facets-clear-all span').trigger('click');
    //   $('.m_drawerRemovableFacets').hide();
    // });
    
    // $('body').on('change', '#facets-drawer input', function(){
    //   var $input = $(this);
    //   if ($input.is(':checkbox')) {
    //     var value = $input.val();
    //     var $existingFacet = $('.m_drawerRemovableFacets .removableFacetsWrapper .removable-facet:contains("' + value + '")');
    //     if ($input.prop('checked')) {
    //       if ($existingFacet.length === 0) {
    //         var removableFacet = '<div class="removable-facet" data-value="'+value+'"><svg style="color: white" aria-hidden="true" focusable="false" fill="none" width="7" class="icon icon-close" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path></svg><span class="text-subdued">'+value+'</span></div>';
    //         $('.m_drawerRemovableFacets .removableFacetsWrapper').append(removableFacet);
    //       }
    //     } else {
    //       $existingFacet.remove();
    //     }
    //   }
    //   if($input.is('[aria-label="From price"]')) {
    //     var value = '≥ '+$input.val();
    //     var $existingFacet = $('.m_drawerRemovableFacets .removableFacetsWrapper .removable-facet.minPrice');
    //     if ($existingFacet.length === 0) {
    //       var removableFacet = '<div class="removable-facet minPrice"><svg style="color: white" aria-hidden="true" focusable="false" fill="none" width="7" class="icon icon-close" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path></svg><span class="text-subdued">'+value+'</span></div>';
    //       $('.m_drawerRemovableFacets .removableFacetsWrapper').append(removableFacet);
    //     } else {
    //       $('.m_drawerRemovableFacets .removableFacetsWrapper .removable-facet.minPrice span').text(value);
    //     }
    //   }
    //   if($input.is('[aria-label="To price"]')) {
    //     var value = '≤ '+$input.val();
    //     var $existingFacet = $('.m_drawerRemovableFacets .removableFacetsWrapper .removable-facet.maxPrice');
    //     if ($existingFacet.length === 0) {
    //       var removableFacet = '<div class="removable-facet maxPrice"><svg style="color: white" aria-hidden="true" focusable="false" fill="none" width="7" class="icon icon-close" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path></svg><span class="text-subdued">'+value+'</span></div>';
    //       $('.m_drawerRemovableFacets .removableFacetsWrapper').append(removableFacet);
    //     } else {
    //       $('.m_drawerRemovableFacets .removableFacetsWrapper .removable-facet.maxPrice span').text(value);
    //     }
    //   }
    //   facetWrapperVisibility();
    // }); 

    // $('body').on('click', '.removableFacetsWrapper .removable-facet', function(e){
    //   e.preventDefault();
    //   $(this).hide();
      
    //   var min_val = parseInt($('.m_rangeInputs').attr('data-min'));
    //   var max_val = parseInt($('.m_rangeInputs').attr('data-max'));
    //   var removeFacet = $(this).find('span').text();
    //   $('#facets-drawer input[value="'+removeFacet+'"]').click(); 
    //   if($(this).hasClass('minPrice')) {
    //     var min = $('#facets-drawer input[type="range"][aria-label="From price"]').attr('min');
    //     $('#facets-drawer input[type="range"][aria-label="From price"], #facets-drawer input[type="number"][aria-label="From price"]').val(min_val).trigger('input');
    //     $('.m-range-group').css('--range-min', '0%');
    //   }
    //   if($(this).hasClass('maxPrice')) {
    //     var max = $('#facets-drawer input[type="range"][aria-label="To price"]').attr('max');
    //     $('#facets-drawer input[type="range"][aria-label="To price"], #facets-drawer input[type="number"][aria-label="To price"]').val(max_val).trigger('input');
    //     $('.m-range-group').css('--range-max', '100%');
    //   }   
    // });

    // $('body').on('click', 'button.m_openFilterDrawer', function(){
    //    autoFetchFacets();
    // });
});

if(getRecommendedProductsStatus()){
/* IIFE function for check status of cart drawer */  
(function () {
  const cartDrawer = document.getElementById('cart-drawer');
  const handleCartDrawerChanges = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        const isOpen = cartDrawer.hasAttribute('open');
        if (isOpen) {
          // console.log('Cart drawer is open');
          $("#m-recommended-products-section").show();
          } else {
          // console.log('Cart drawer is closed');
          $("#m-recommended-products-section").hide();
        }
      }
    }
  };
  const initialIsOpen = cartDrawer.hasAttribute('open');
  if (initialIsOpen) {
    // console.log('Cart drawer is initially open');
    $("#m-recommended-products-section").show();
  } else {
    // console.log('Cart drawer is initially closed');
    $("#m-recommended-products-section").hide();
  }
  const observer = new MutationObserver(handleCartDrawerChanges);
  const config = { attributes: true };
  observer.observe(cartDrawer, config);
})(); 

/* Add to cart recommended products */  
$("body").on("click", "button.m-recommended-product-atc", function(e){
  const $_this = $(this);
  e.preventDefault()
   const quantityValue = $(this).closest(".m-recommended-products-item").find(".quantity-selector__input").val();
   const var_id = $(this).closest(".m-recommended-products-item").find(".m-recommended-product-variants").val();
  
    if(var_id !== null){
      $_this.parent().addClass("active");
        let formData = {
        'items': [{
          'id':var_id,
          'quantity': quantityValue
        }]
    };
   window.addToCart(formData,'refresh_drawer' );
  }else{
    $_this.closest(".m-recommended-products-item").find(".m-recommended-product-variants-outer").addClass("active");
    console.log("Select your size");
  }
});

/* Select variant id onchange variant selectbox recommended products */  
$('body').on('change', '.m-recommended-product-variants', function () {
  $(this).parent().removeClass("active");
  const id = $(this).val();
  $(this).closest(".m-recommended-products-item").find(".m-recommended-product-atc").attr("data-variant-id", id);
});

/* Scrolling recommended product in desktop */  
window.initializeSlider = function() {
  const slider = document.querySelector('.m-recommended-products-row');
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });

  // Touch events
  slider.addEventListener('touchstart', (e) => {
    isDown = true;
    startX = e.touches[0].pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('touchend', () => {
    isDown = false;
  });

  slider.addEventListener('touchmove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.touches[0].pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
};

/* Recommended product filter */
window.filterAndShowProducts = function() {
    const colorArray = [];
    $(".m__cart__drawer__items .line-item").each(function() {
        const color = $(this).attr("data-color");
        if (colorArray.indexOf(color) === -1) {
            colorArray.push(color);
        }
    });
  
    $(".m-recommended-products-item").hide();
    colorArray.forEach(function(color) {
        $(".m-recommended-products-item[data-color='" + color + "']").show();
    });
};
  
/* Function to be called when the Discount badge element is added or removed */  
(function() {
    function handleChanges(mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                if ($(mutation.addedNodes).find('.m-discount-badges-row').length > 0) {
                    $("#m-recommended-products-section").css("top", "360px");
                } else if ($(mutation.removedNodes).find('.m-discount-badges-row').length > 0) {
                    $("#m-recommended-products-section").css("top", "320px");
                }
            }
        }
    }
    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    const observer = new MutationObserver(handleChanges);
    if (window.isMobileDevice()) {
        observer.observe(targetNode, config);
    }
})();

$("body").on("click", "#recommended-products-close", function() {
    $("#m-recommended-products-section").hide();
});
}
// Attach the lazy load function to the window object
window.initLazyLoad = function() {
  // console.log("window.initLazyLoad called");
  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const image = entry.target;
        const dataSrc = image.getAttribute("m-data-src");

        if (dataSrc) {
          image.classList.add("visible"); 
          image.setAttribute("src", dataSrc);
          observer.unobserve(image);
        }
      }
    });
  }

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1
  };

  const observer = new IntersectionObserver(handleIntersection, observerOptions);
  document.querySelectorAll("img[m-data-src]").forEach(image => {
    observer.observe(image);
  });

  document.body.addEventListener("load", function(event) {
    const target = event.target;
    if (target.tagName === "IMG" && target.getAttribute("m-data-src")) {
      observer.observe(target);
    }
  }, true);
};


var $offerModal = $('#buyMoreSaveMorePopup');
var $offerBtn = $('.m_offerMain a');
var $closeBtn = $('.offerPopupClose');

$offerBtn.on('click', function() {
  if ($(window).width() <= 768) {
    $offerModal.find('.offerPopupContent').css('animation', 'bottomUpMobileOpen 0.5s forwards ease-in-out');
  } else {
    $offerModal.find('.offerPopupContent').css('animation', 'bottomUpDesktopOpen 0.5s forwards ease-in-out');
  }
  $offerModal.show();
});

$closeBtn.on('click', function() {
  if ($(window).width() <= 768) {
    $offerModal.find('.offerPopupContent').css('animation', 'bottomUpMobileClose 0.5s forwards ease-in-out');
  } else {
    $offerModal.find('.offerPopupContent').css('animation', 'bottomUpDesktopClose 0.5s forwards ease-in-out');
  }
  setTimeout(function() {
    $offerModal.hide();
  }, 500);
});

$(window).on('click', function(event) {
  if ($(event.target).is($offerModal)) {
    if ($(window).width() <= 768) {
      $offerModal.find('.offerPopupContent').css('animation', 'bottomUpMobileClose 0.5s forwards ease-in-out');
    } else {
      $offerModal.find('.offerPopupContent').css('animation', 'bottomUpDesktopClose 0.5s forwards ease-in-out');
    }
    setTimeout(function() {
      $offerModal.hide();
    }, 500);
  }
});


function addToCartWithPromise(formData, behavior) {
  return new Promise((resolve, reject) => {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        // If the response is not successful (like a 422 status), reject the promise
        return response.json().then((errorData) => reject(errorData));
      }
      return response.json();
    })
    .then(() => {
      // Dispatch events to refresh the cart UI
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));

      // Handle the drawer opening ONLY if add-to-cart is successful
      if (behavior === 'open_drawer') {
        resolve('open_drawer');
      } else if (behavior === 'refresh_drawer') {
        resolve('refresh_drawer');
      } else {
        window.location.reload();
        resolve('reload');
      }
    })
    .catch((error) => {
      // Handle any errors and reject the promise with the error
      reject(error);
    });
  });
}

$(document).ready(function() {

  $('body').on('click', '.m_collectionToolbar details', function () {
  if (this.open) {
    $(this).closest('.m_collectionToolbar').find('details').not(this).removeAttr('open');
  }
});


  $('body').on('click', '.closeFilterDropdown', function(e){
    e.preventDefault();
    $(this).closest('details').attr('aria-expanded', false);
  }); 

  var $fieldsetElement = $('.size-fieldset');
  var $radioButtonsList = $fieldsetElement.find('input[type="radio"]');

  function areAllSizeOptionsUnchecked() {
    return $radioButtonsList.filter(':checked').length === 0;
  }

  $radioButtonsList.on('click', function() {
    $(".m_buyMoreSaveMoreButtons").removeClass("active");
  });

  $('body').on('click', '.m_buyMoreSaveMoreButtons button', function() {
    if (areAllSizeOptionsUnchecked() && $fieldsetElement.length > 0) {
      $(".m_buyMoreSaveMoreButtons").addClass("active");
    } else {
      $(".m_buyMoreSaveMoreButtons").removeClass("active");
      var selectedOptionValue = $('.atc_btn-input').val();
      var quantity = $(this).attr('data-quantity');
      var $clickedButton = $(this);
      var originalText = $clickedButton.html(); 
      var $errorMessageContainer = $('.offer-error-message');
      
      if (selectedOptionValue !== null) {
        let formData = {
          'items': [{
            'id': selectedOptionValue,
            'quantity': quantity
          }]
        };

        // Use the updated addToCartWithPromise function
        addToCartWithPromise(formData, 'open_drawer')
          .then(function(behavior) {
            // If the product is added successfully, handle behavior
            if (behavior === 'open_drawer') {
              $('[data-cart-drawer-open]').click(); // Open the drawer only after a successful add
            }

            // Update button text to indicate success
            $clickedButton.html('<h3>Added!</h3>');
            setTimeout(function() {
              $clickedButton.html(originalText);
            }, 2000);
          })
          .catch(function(error) {
            // Show error message if there's an issue
            if (error && error.description) {
              $errorMessageContainer.text(error.description).show();
            } else {
              $errorMessageContainer.text('Failed to add to cart!').show();
            }

            console.error('Failed to add to cart:', error);
            setTimeout(function() {
              $errorMessageContainer.hide();
            }, 5000);
          });
      }
    }
  });


  
});

document.addEventListener("click", function (e) {
  const accordion = document.querySelector("details.accordion[open]");
  if (!accordion) return; // no open accordion, do nothing

  const content = accordion.querySelector(".m_accordion__content");
  const summary = accordion.querySelector("summary");

  // if click is outside both content and summary → close
  if (!content.contains(e.target) && !summary.contains(e.target)) {
    accordion.removeAttribute("open");
  }
});